<!--
 * @Description: 客户价值 模块
-->
<template>
  <div class="value">
    <section class="value_card value_bg_img rn-section-gap">
      <div class="container value_content">
        <SectionTitle
          :title="$t('solution.values_title')"
          description="VALUES"
          textAlign="center"
        />
        <div class="card_img">
          <img src="@/assets/images/IndustrySolution/crm/value_img.png" />
          <div v-if="valueStyle === 1">
            <div class="row">
              <div class="card_tab col-lg-6 col-md-6 col-sm-12 col-12 p-3">
                <div class="tab_content col-lg-8 col-md-11 col-sm-12 col-12  mb--30"  v-for="(item, index) in list_left" :key="index">
                  <h5 v-if="item.title">
                    {{ item.title }}
                  </h5>
                  <p v-if="item.desc">
                    {{ item.desc }}
                  </p>
                </div>
              </div>
              <div class="card_tab col-lg-6 col-md-6 col-sm-12 col-12 p-3 row">
                <div class="tab_content col-lg-8 col-md-11 col-sm-12 col-12 offset-lg-4 offset-md-1 mb--30" v-for="(item, index) in list_right" :key="index">
                  <h5 v-if="item.title">
                    {{ item.title }}
                  </h5>
                  <p v-if="item.desc">
                    {{ item.desc }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="valueStyle === 2">
            <div class="row card_tab3">
              <div class="col-lg-4 col-md-5 col-12 mb--30" 
              :class="[
                  {'offset-lg-4 offset-md-2 tab_content_right ':index %2 ===1},
                  {'tab_content_left':index %2 ===0},
                  {'translate-50-y':index %2 ===1 && list.length%2 ===1},
                ]"  v-for="(item, index) in list" :key="index">
                <h5 v-if="item.title">
                  {{ item.title }}
                </h5>
                <p  v-if="item.desc">
                  {{ item.desc }}
                </p>
              </div>
              
            </div>
          </div>
          <div v-if="valueStyle === 3">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="card_tab3 col-lg-8 col-md-11 col-sm-12 col-12 p-4">
                  <div class="tab_content_left">
                    <h5 v-if="list[0].title">
                      {{ list[0].title }}
                    </h5>
                    <div v-if="list[0].desc && typeof list[0].desc === 'string'">
                      <p>
                        {{ list[0].desc }}
                      </p>
                    </div>
                    <div v-else>
                      <p v-for="(ite, index) in list[0].desc" :key="index">
                        {{ ite.title }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                <div
                  v-for="(item, index) in list.slice(1)"
                  :key="index"
                  class="card_tab3 col-lg-8 col-md-11 col-sm-12 col-12 p-4 offset-lg-4 offset-md-1"
                >
                  <div class="tab_content_right">
                    <h5 v-if="item.title">
                      {{ item.title }}
                    </h5>
                    <div v-if="item.desc && typeof item.desc === 'string'">
                      <p>
                        {{ item.desc }}
                      </p>
                    </div>
                    <div v-else>
                      <p v-for="(ite, index) in item.desc" :key="index">
                        {{ ite.title }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'

export default {
  name: 'Value',
  components: { SectionTitle },
  computed:{
    list_left(){
      return this.list.filter((item,index)=>index%2 === 0)
    },
    list_right(){
      return this.list.filter((item,index)=>index%2 === 1)
    }
  },
  props: {
    valueStyle: {
      type: Number,
      default: 1
    },
    /**
     * list: 数组
     * 格式：[{ title: '1', desc:'1' },{ title: '2', desc:'2' }]
     * 没title格式：[{ desc:'1' },{ desc:'2' }]
     */
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>